import { c as _c } from "react/compiler-runtime";
// `<OgLogomark>` — Morfi brand mark for OG cards.
//
// Renders the canonical favicon swoosh (`/public/icons/favicon.png`) as a
// base64-inlined PNG so it's byte-identical in Satori (Edge OG renderer)
// and in the browser-rendered JSX preview, without depending on a
// fetchable origin URL.
//
// Aspect ratio is square (1:1). Use this primitive anywhere a small
// circular brand mark is needed inside a card — handle pills, chrome
// corners, fallback states.

import { BRAND_MARK_DATA_URL } from '../__internal__/brand-mark';
export interface OgLogomarkProps {
  /** Side length in pixels. */
  size: number;
}
export function OgLogomark(t0) {
  const $ = _c(10);
  const {
    size
  } = t0;
  let t1;
  if ($[0] !== size) {
    t1 = {
      display: "flex",
      width: size,
      height: size
    };
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== size) {
    t2 = {
      width: size,
      height: size,
      display: "block"
    };
    $[2] = size;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== size || $[5] !== t2) {
    t3 = <img src={BRAND_MARK_DATA_URL} alt="Morfi" width={size} height={size} style={t2} />;
    $[4] = size;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div style={t1}>{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}